var _excluded = ["active", "onToggle", "children", "requireChildren", "placement", "dropdown", "capture", "data-qa", "as", "classNames", "className", "zIndex"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { useCallback, forwardRef } from "react";
import OuterClickListener from "@components/outer-click-listener";
import { useBoolean, useBox } from "@ati/hooks";
import { joinCn, zIndexSystem } from "@ati/uti";
var zIndexDefault = {
  dropdown: zIndexSystem.dropdownList // glz-z-dropdown-list
};

var DropdownToggle = (_ref, ref) => {
  var {
      active,
      onToggle,
      children,
      requireChildren = true,
      placement = "bottom-right",
      dropdown,
      capture,
      "data-qa": dataQa = "dropdown-toggle",
      as,
      classNames = {},
      className,
      zIndex = zIndexDefault
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var [innerActive, toggleInnerActive] = useBoolean(false);
  var activeBox = useBox(active);
  var innerActiveBox = useBox(innerActive);
  var onToggleBox = useBox(onToggle);
  var handleToggle = useCallback(event => {
    event.stopPropagation();
    if (typeof activeBox.current === "boolean" && onToggleBox.current) {
      /**
       * Если активное состояние управляется снаружи.
       */
      onToggleBox.current(!activeBox.current, event);
    } else {
      /**
       * Если активное состояние управляется изнутри.
       */
      toggleInnerActive();
    }
    return null;
  }, []);
  var handleTriggerClick = useCallback(e => {
    if (rest.onClick) {
      rest.onClick(e);
    }
    if (typeof activeBox.current === "boolean" && !activeBox.current || !innerActiveBox.current) {
      // @ts-ignore
      handleToggle(e);
    }
  }, [handleToggle]);
  var As = as !== null && as !== void 0 ? as : "button";
  var buttonProps = As === "button" ? {
    type: "button"
  } : {};
  return children || !requireChildren ? /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-qa": dataQa,
    className: joinCn("glz-dropdown-toggle", classNames.wrapper, className)
  }, /*#__PURE__*/React.createElement(As, _extends({}, buttonProps, rest, {
    className: joinCn("glz-trigger", classNames.trigger),
    onClick: handleTriggerClick,
    "data-qa": "dropdown-toggle-trigger"
  }), children), (typeof active === "boolean" ? active : innerActive) && !!dropdown && /*#__PURE__*/React.createElement(OuterClickListener, {
    className: joinCn("glz-dropdown", "glz-is-".concat(placement), classNames.dropdown),
    onClickOutside: handleToggle,
    capture: capture,
    "data-qa": "dropdown",
    style: {
      zIndex: zIndex.dropdown
    }
  }, dropdown)) : null;
};

// Подробнее об этих поворотах-заворотах можно глянуть здесь https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
var DropdownToggleRef = forwardRef(DropdownToggle);
export default DropdownToggleRef;